module.exports = __webpack_public_path__ + "images/home/tempBackgroundHome.896137db.png";